import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { BusinessUnit } from "src/app/shared/models/business-unit";

@Injectable({
  providedIn: "root",
})
export class BusinessUnitService {
  constructor(private http: HttpClient) {}

  apiRoot = `${environment.apiUrl}BusinessUnit`;

  public getBusinessUnitId(abv: string): Observable<BusinessUnit> {
    return this.http.get<BusinessUnit>(
      `${this.apiRoot}/getBusinessUnit/${abv}`
    );
  }

  public getBusinessUnitByUserUniqueKey(
    uniqueKey: string
  ): Observable<BusinessUnit> {
    return this.http.get<BusinessUnit>(
      `${this.apiRoot}/getBusinessUnitByUserUniqueKey/${uniqueKey}`
    );
  }

  public getBusinessUnitMinimumRating(abv: string): Observable<number> {
    return this.http.get<number>(
      `${this.apiRoot}/getBusinessUnitMinimumRating/${abv}`
    );
  }

  public updateBusinessUnitMinimumRating(abv: string, minRating: number) {
    return this.http.put<void>(
      `${this.apiRoot}/updateBusinessUnitMinimumRating/${abv}/${minRating}`,
      null
    );
  }

  public updateBusinessUnitFieldsToInfer(
    abv: string,
    newFieldsToInfer: string
  ): Observable<string> {
    return this.http.put(
      `${this.apiRoot}/updateBusinessUnitFieldsToInfer/${abv}/${newFieldsToInfer}`,
      null,
      { responseType: "text" }
    );
  }
}
